import type { Session } from './types';
import { toDateSafe, type DateInput } from './dates';

export function conferenceHeaderLabel(startAt: DateInput) {
  const date = toDateSafe(startAt);
  if (!date) return 'Conference - TBD';
  const parts = new Intl.DateTimeFormat('en-GB', {
    timeZone: 'Europe/London', weekday: 'long', day: 'numeric', month: 'long', year: 'numeric'
  }).formatToParts(date);
  const part = (type: Intl.DateTimeFormatPartTypes) => parts.find((item) => item.type === type)?.value || '';
  const day = Number(part('day'));
  const suffix = day % 100 >= 11 && day % 100 <= 13 ? 'th' : ({ 1: 'st', 2: 'nd', 3: 'rd' }[day % 10] || 'th');
  return `Conference - ${part('weekday')} ${day}${suffix} ${part('month')} ${part('year')}`;
}

const DISCUSSION_ENABLED_TITLES = new Set(['syteline roadmap', 'infor leaders q&a', 'agm & prize draw']);
const LOGISTICS_TITLES = new Set([
  'registration & pastries',
  'registration, refreshments and networking',
  'changeover break',
  'refreshments and networking',
  'lunch & networking',
  'lunch and networking',
  'coffee break',
  'close',
]);

export function sessionHasDiscussion(session: Pick<Session, 'title' | 'hideInterest'>) {
  return !session.hideInterest || DISCUSSION_ENABLED_TITLES.has(session.title.trim().toLowerCase());
}

export function sessionHasDetail(
  session: Pick<Session, 'title' | 'hideInterest' | 'detailEnabled'> & Pick<Partial<Session>, 'polls'>
) {
  return session.detailEnabled === true || Boolean(session.polls?.length) || sessionHasDiscussion(session);
}

export function sessionRepliesEnabled(session: Pick<Session, 'title' | 'hideInterest' | 'repliesEnabled'>) {
  return session.repliesEnabled !== false && sessionHasDiscussion(session);
}

export function isLogisticsSession(session: Pick<Session, 'title'>) {
  return LOGISTICS_TITLES.has(session.title.trim().toLowerCase());
}
